import { FGButton, FGStack, FGTypography } from '@fg/design-system';
import React from 'react';

//todo: remove this file and move this const somewhere else
export const METHODOLOGIES_PDF_URL = 'https://fitch-gq-static-content-production.s3.us-east-1.amazonaws.com/papers/BMI_Geo_Risk_Signals_Methodology.pdf';
//Todo: add link/rediectioon
const Methodologies = React.memo(() => {
    return (
        <FGStack
            direction="column"
            justifyContent="center"
            alignItems="center"
            style={{ width: '100%', height: '100%' }}>
            <FGStack
                direction="column"
                justifyContent="flex-start"
                style={{ width: '50%', height: '50%' }}>
                <FGTypography tag="h2" variant="headline2">
                    Methodologies PDF
                </FGTypography>
                <FGButton
                    onClick={() => window.open(METHODOLOGIES_PDF_URL, '_blank')}
                    variant="secondary">
                    <FGTypography color="strong" tag="h3" variant="headline3">
                        View PDF
                    </FGTypography>
                </FGButton>
            </FGStack>
        </FGStack>
    );
});

export default Methodologies;
